import en from './en'
import fr from './fr'
import nl from './nl'

export const messages = { en, fr, nl }

export type MessageLanguages = keyof typeof messages
export type MessageSchema = typeof en

export { en, fr, nl }
